module.exports = __webpack_public_path__ + "img/parking-lot-4.b99158eb.jpg";